import { Route, Routes } from "react-router-dom";
import TabletInventory from "./pages/TabletInventory";

export function TabletInventoryManagementRoutes() {
	return (
		<Routes>
			<Route index element={<TabletInventory />} />
		</Routes>
	);
}
